export default __webpack_public_path__ + "static/media/apple-icon-152x152.f1ea29d7.png";